"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _router = require("@reach/router");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _lodash = require("lodash");

var _antd = require("antd");

var _redux = require("../../redux");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

var EditorWrapper = function EditorWrapper(props) {
  var sidebarOptions = props.sidebarOptions,
      loaded = props.loaded,
      locked = props.locked,
      children = props.children;

  var _ref3 = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      _ref3$cms$editor = _ref3.cms.editor,
      siteHasChanged = _ref3$cms$editor.siteHasChanged,
      postHasChanged = _ref3$cms$editor.postHasChanged,
      changeIndex = _ref3$cms$editor.changeIndex;

  var dispatch = (0, _redux.useAppDispatch)(); // We need the window width to calculate scaling

  var _ref4 = (0, _react.useState)(null),
      _ref5 = _slicedToArray(_ref4, 2),
      windowWidth = _ref5[0],
      setWindowWidth = _ref5[1];

  (0, _react.useEffect)(function () {
    setWindowWidth(window.innerWidth);
  }, []);
  (0, _react.useEffect)(function () {
    var debouncedHandleResize = (0, _lodash.debounce)(function () {
      setWindowWidth(window.innerWidth);
    }, 100);
    window.addEventListener('resize', debouncedHandleResize);
    return function () {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, []);
  (0, _react.useEffect)(function () {
    var _document$querySelect; // Disable all links on the page as soon as the content has changed


    var anchors = ((_document$querySelect = document.querySelector('#jam-cms')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.querySelectorAll('a')) || [];

    for (var i = 0; i < anchors.length; i++) {
      anchors[i].onclick = function (e) {
        var _e$target; // Always allow links which open in a new browser tab


        if (((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.target) === '_blank') {
          return true;
        }

        if (siteHasChanged || postHasChanged) {
          e.preventDefault(); // Display confirmation dialog

          dispatch(_redux.uiActions.showDialog({
            open: true,
            title: 'Warning',
            component: /*#__PURE__*/_react.default.createElement(_antd.Space, {
              direction: "vertical",
              size: 20
            }, /*#__PURE__*/_react.default.createElement(_antd.Typography, {
              children: 'There are unsaved changes. Are you sure you want to discard them?'
            }), /*#__PURE__*/_react.default.createElement(_antd.Space, null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
              children: "Cancel",
              onClick: function onClick() {
                return dispatch(_redux.uiActions.hideDialog());
              }
            }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
              children: "Discard changes",
              danger: true,
              type: "primary",
              onClick: function onClick() {
                var _e$path; // Clicking on a tags with nested elements (i.e. span) returns the wrong 'target'. That's why we need to find the correct node ourselves.


                var node = (e === null || e === void 0 ? void 0 : (_e$path = e.path) === null || _e$path === void 0 ? void 0 : _e$path.length) && e.path.find(function (o) {
                  return o.href;
                });

                if (node) {
                  (0, _router.navigate)(node.href);
                }

                dispatch(_redux.uiActions.hideDialog());
              }
            }))),
            width: 320
          }));
        }
      };
    }
  }, [changeIndex]);
  return /*#__PURE__*/_react.default.createElement(Container, {
    id: "jam-cms",
    loaded: loaded,
    locked: locked,
    sidebar: sidebarOptions
  }, /*#__PURE__*/_react.default.createElement(Inner, {
    loaded: loaded,
    locked: locked,
    sidebar: sidebarOptions,
    windowWidth: windowWidth
  }, children));
};

var Container = (0, _styledComponents.default)('div')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n"])), function (_ref) {
  var loaded = _ref.loaded,
      locked = _ref.locked,
      _ref$sidebar = _ref.sidebar,
      style = _ref$sidebar.style,
      active = _ref$sidebar.active;
  return loaded && !locked && style === 'scale' && active && (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      height: 100vh;\n    "])));
});
var Inner = (0, _styledComponents.default)('div')(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n"])), function (_ref2) {
  var loaded = _ref2.loaded,
      locked = _ref2.locked,
      _ref2$sidebar = _ref2.sidebar,
      style = _ref2$sidebar.style,
      active = _ref2$sidebar.active,
      position = _ref2$sidebar.position,
      width = _ref2$sidebar.width,
      windowWidth = _ref2.windowWidth;
  return loaded && !locked && (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      ", "\n    "])), style === 'scale' ? active && (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n            transform: ", ";\n            transform-origin: ", " top;\n          "])), windowWidth && "scale(".concat(1 - width / windowWidth, ")"), position === 'left' ? 'right' : 'left') : style === 'inline' ? (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n            width: ", ";\n            margin-left: ", ";\n            margin-right: ", ";\n          "])), active ? "calc(100% - ".concat(width, "px)") : '100%', position === 'left' && active ? "".concat(width, "px") : 0, position === 'right' && active ? "".concat(width, "px") : 0) : style === 'overflow' && (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)([""]))));
});
var _default = EditorWrapper;
exports.default = _default;